(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const isFormBased = document.querySelector('.product_mainform');
    const isRadioBased = document.querySelector('.variant-radio, .variant-option');

    const variants = getVariantsData();
    if (!variants.length) {
      console.warn('No variant data found');
      return;
    }

    if (isFormBased) initFormBasedHandler(variants);
    if (isRadioBased) initRadioBasedHandler(variants);
  });

  function getVariantsData() {
    if (window.productVariants) return window.productVariants;
    const form = document.querySelector('.product_mainform');
    if (!form) return [];
    try {
      return JSON.parse(decodeURIComponent(form.getAttribute('data-variants')));
    } catch (err) {
      console.error('Error parsing variants JSON:', err);
      return [];
    }
  }

  /**
   * FORM-BASED HANDLER (old product system)
   */
  function initFormBasedHandler(variants) {
    const form = document.querySelector('.product_mainform');
    if (!form) return;

    form.addEventListener('change', (e) => {
      if (e.target.name.includes('option')) updateVariantUI();
    });

    function getActiveVariant() {
      const formData = new FormData(form);
      const options = Object.fromEntries(formData.entries());
      return variants.find((v) =>
        v.option1 === options.option1 &&
        (!options.option2 || v.option2 === options.option2) &&
        (!options.option3 || v.option3 === options.option3)
      );
    }

    function updateVariantUI() {
      const variant = getActiveVariant();
      if (!variant) return;
      updateProductUI(variant);

      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;
      window.history.replaceState(null, null, `?variant=${variant.id}`);

      changePrice(variant);
      hideCompareAtPriceElement(variant);
      if (window.ProductVisuals) ProductVisuals.updateMedia(variant);
      displayColorName(variant);
      updateHiddenInput(variant);
    }
  }

  /**
   * RADIO/SELECT HANDLER (new product system)
   */
  function initRadioBasedHandler(variants) {
    const radios = document.querySelectorAll('.variant-radio');
    const selects = document.querySelectorAll('.variant-option');

    [...radios, ...selects].forEach((input) => {
      input.addEventListener('change', handleVariantChange);
      input.addEventListener('click', handleVariantChange);
    });

    function handleVariantChange() {
      const selections = getSelections();
      const variant = findSelectedVariant(variants, selections);
      if (!variant) return;

      // Highlight active selection visually
      if (this.closest('.radio-option')) {
        const optionContainer = this.closest('.radio-option');
        optionContainer.querySelectorAll('div.pos_relative label').forEach((l) => l.classList.remove('active'));
        this.closest('.radioinput')?.querySelector('label')?.classList.add('active');
      }

      updateURL(variant);
      updateHiddenInput(variant);
      changePrice(variant);
      hideCompareAtPriceElement(variant);
      if (window.ProductVisuals) ProductVisuals.updateMedia(variant);
      updateOutOfStockStatusForOption(selections);
      updateProductUI(variant);
    }

    function getSelections() {
      const selections = {};
      document.querySelectorAll('[data-option-name]').forEach((el) => {
        if (el.type === 'radio' && !el.checked) return;
        selections[el.getAttribute('data-option-name')] = el.value;
      });
      return selections;
    }

    function findSelectedVariant(variants, selections) {
      const opts = Object.values(selections);
      return variants.find((v) => v.options.join(',') === opts.join(','));
    }
  }

  /**
   * COMMON SHARED FUNCTIONS (used by both product types)
   */

  function changePrice(variant) {
    const priceEl = document.querySelector('.price_diff .formattedMainPrice');
    const centsEl = document.querySelector('.price_diff .formattedCentsPrice');
    const oldPriceEl = document.querySelector('span.js-old-price');
    const percentEls = document.querySelectorAll('.js-percent-off');
    const afterpayEl = document.querySelector('span.js-afterpay-payments');
    const saveEl = document.querySelector('span.js-save');

    let newPrice = variant.price / 100;
    let oldPrice = variant.compare_at_price / 100;

    // Price formatting: show integer + cents only if needed
    if (priceEl) {
      if (Number.isInteger(newPrice)) {
        priceEl.textContent = newPrice.toFixed(0);
        if (centsEl) centsEl.style.display = 'none';
      } else {
        const parts = newPrice.toFixed(2).split('.');
        priceEl.textContent = parts[0];
        if (centsEl) {
          centsEl.textContent = '.' + parts[1];
          centsEl.style.display = 'inline';
        }
      }
    }

    if (oldPriceEl) {
      if (Number.isInteger(oldPrice)) {
        oldPriceEl.textContent = '$' + oldPrice.toFixed(0);
      } else {
        oldPriceEl.textContent = '$' + oldPrice.toFixed(2).replace(/\.00$/, '');
      }
    }

    const percentOff = Math.floor(((oldPrice - newPrice) / oldPrice) * 100);
    percentEls.forEach((el) => (el.textContent = percentOff));

const afterpayAmount = (newPrice / 4).toFixed(2);
document.querySelectorAll('.js-afterpay-payments').forEach((el) => {
  el.textContent = '$' + afterpayAmount;
});

// Update savings display
if (saveEl) saveEl.textContent = '$' + (oldPrice - newPrice).toFixed(2);
  }

  function hideCompareAtPriceElement(variant) {
    const el = document.querySelector('.product-action');
    if (!el) return;
    if (variant.compare_at_price <= 0) el.classList.add('hide_compare_at');
    else el.classList.remove('hide_compare_at');
  }

  // function toggleLeaveWarehouse(variant) {
  //   const el = document.getElementById('leave-warehouse-content');
  //   if (!el) return;
  //   el.style.display = variant.available ? 'block' : 'none';
  // }

  function displayColorName(variant) {
    const color = variant.option3 || variant.option2 || variant.option1;
    const colorEl = document.querySelector('.optionColorName');
    if (!colorEl) return;
    colorEl.textContent = color || '';
  }

  function updateHiddenInput(variant) {
    const hiddenInput = document.querySelector('form input[name="id"]');
    if (hiddenInput) hiddenInput.value = variant.id;
    const btnInput = document.querySelector('form.buttonproduct input.product-variant-id');
    if (btnInput) btnInput.setAttribute('value', variant.id);
  }

  function updateURL(variant) {
    window.history.replaceState(null, null, `?variant=${variant.id}`);
  }

  function updateOutOfStockStatusForOption(selections) {
    Object.keys(selections).slice(1).forEach((optName) => {
      document.querySelectorAll(`input[data-option-name="${optName}"]`).forEach((input) => {
        const val = input.value;
        const possible = { ...selections, [optName]: val };
        const inStock = window.productVariants?.some((v) => {
          return Object.keys(possible).every((k, i) => v[`option${i + 1}`] === possible[k]) &&
            (v.inventory_quantity > 0 || v.inventory_policy === 'continue');
        });
        input.nextElementSibling?.classList.toggle('outofstock', !inStock);
      });
    });
  }
})();